import ChatPage from './ChatPage'

export default ChatPage
